import Head from "next/head"

import "styles.css"

import "@fontsource/figtree/latin-300.css"
import "@fontsource/figtree/latin-400.css"
import "@fontsource/figtree/latin-500.css"
import "@fontsource/figtree/latin-600.css"
import "@fontsource/figtree/latin-700.css"
import "@fontsource/figtree/latin-800.css"
import "@fontsource/figtree/latin-900.css"

import PreviewAlert from "components/PreviewAlert"
import Footer from "components/Footer"

import useStoryblok from "storyblok/useStoryblok"
import { resolve_relations } from "storyblok/resolveRelations"

function MyApp({ Component, pageProps: { preview, story, globals, ...remainingProps } }) {
  story = useStoryblok({ story, resolve_relations })

  return (
    <>
      <Head>
        <title>25 Transformative Moments Across 25 Years | Federal News Network</title>
        <link rel="icon" type="image/png" href="favicon/favicon-96x96.png" sizes="96x96" />
        <link rel="icon" type="image/svg+xml" href="favicon/favicon.svg" />
        <link rel="shortcut icon" href="favicon/favicon.ico" />
        <link rel="apple-touch-icon" sizes="180x180" href="favicon/apple-touch-icon.png" />
        <meta name="apple-mobile-web-app-title" content="FNN Top 25" />
        <link rel="manifest" href="favicon/site.webmanifest" />
      </Head>
      {preview && <PreviewAlert />}
      <svg xmlns="http://www.w3.org/2000/svg" height="0" width="0">
        <defs>
          <clipPath id="banner">
            <path d="M0 0.626709H1180L1132 60.6267L1180 126.627H0L46 60.6267L0 0.626709Z" />
          </clipPath>
        </defs>
      </svg>

      <Component story={story} {...remainingProps} />
      <Footer globals={globals} />
    </>
  )
}

export default MyApp
